import { get,post } from "./Api";

export function SearchEmployee({ lineId }) {
  return get({ url: `/api/v1/haire/employee/search/proflie/${lineId}`});
}

export function UpdateEmployee({ data }) {
  return post({ url: `/api/v1/haire/employee/update/proflie` , data});
}

export function UpdateMember({ data }) {
  return post({ url: `/api/v1/haire/member/update/proflie` , data});
}

export function SearchEmployeeList({ data }) {
  return post({ url: `/api/v1/haire/employee/search/employeeinfo` , data});
}

export function DeleteEmployee({ data }) {
  return post({ url: `/api/v1/haire/employee/delete` , data});
}



